import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, withKeys as _withKeys, renderList as _renderList, Fragment as _Fragment, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-3f1c4f12")

_pushScopeId("data-v-3f1c4f12")
const _hoisted_1 = { class: "signup-form" }
const _hoisted_2 = {
  key: 0,
  class: "perks"
}
const _hoisted_3 = {
  key: 1,
  class: "subheading"
}
const _hoisted_4 = /*#__PURE__*/_createTextVNode("SUBMIT")
_popScopeId()

export const render = /*#__PURE__*/_withId(function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_header_loyalty = _resolveComponent("header-loyalty")
  const _component_ion_button = _resolveComponent("ion-button")
  const _component_ion_input = _resolveComponent("ion-input")
  const _component_ion_item = _resolveComponent("ion-item")
  const _component_ion_page = _resolveComponent("ion-page")

  return (_ctx.actionUrl)
    ? (_openBlock(), _createBlock(_component_ion_page, { key: 0 }, {
        default: _withId(() => [
          _createVNode(_component_header_loyalty),
          _createVNode("div", _hoisted_1, [
            (_ctx.perks)
              ? (_openBlock(), _createBlock("p", _hoisted_2, _toDisplayString(_ctx.perks), 1))
              : _createCommentVNode("", true),
            (_ctx.offer)
              ? (_openBlock(), _createBlock("h2", _hoisted_3, _toDisplayString(_ctx.offer), 1))
              : _createCommentVNode("", true),
            _createVNode(_component_ion_item, null, {
              default: _withId(() => [
                _createVNode(_component_ion_button, {
                  class: "form-submit",
                  size: "large",
                  fill: "solid",
                  onClick: _cache[1] || (_cache[1] = $event => (_ctx.loyaltySignupGuest($event)))
                }, {
                  default: _withId(() => [
                    _hoisted_4
                  ]),
                  _: 1
                }),
                _createVNode(_component_ion_input, {
                  name: "phone",
                  placeholder: "NUMBER",
                  type: "tel",
                  inputmode: "tel",
                  modelValue: _ctx.phone,
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => (_ctx.phone = $event)),
                  onKeypress: _cache[3] || (_cache[3] = _withKeys(_withModifiers($event => (_ctx.loyaltySignupGuest($event)), ["prevent"]), ["enter"])),
                  onIonFocus: _cache[4] || (_cache[4] = $event => (_ctx.phoneFocus($event))),
                  required: "",
                  clearInput: true
                }, null, 8, ["modelValue"])
              ]),
              _: 1
            }),
            (_ctx.errors)
              ? (_openBlock(), _createBlock(_component_ion_item, { key: 2 }, {
                  default: _withId(() => [
                    (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.errors, (error) => {
                      return (_openBlock(), _createBlock("p", {
                        class: "error-message",
                        key: error,
                        textContent: error
                      }, null, 8, ["textContent"]))
                    }), 128 /* KEYED_FRAGMENT */))
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ])
        ]),
        _: 1
      }))
    : _createCommentVNode("", true)
})